import Vue from 'vue'
import axios from 'axios'
import store from '@/store/index'
import router from '@/router'

axios.defaults.baseURL = 'https://hyclx.yuanrencz.cn/data/api.php/'

axios.defaults.timeout = 15000
Vue.prototype.$ajax = axios

axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    config.headers['Content-Type'] = 'application/json;charset=utf-8'
    const token = store.state.token
    token && (config.headers.Authorization = token)
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
  if (response.data.errno === -1) { // 登录过期
    if (process.env.NODE_ENV === 'development') {
      router.push('/Wxlogin')
    } else {
      router.push('/Oauth')
    }
    return response
  } else {
    return response
  }
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '错误请求'
        break
      case 401:
        err.message = '未授权，请重新登录'
        break
      case 403:
        err.message = '拒绝访问'
        break
      case 404:
        err.message = '请求错误,未找到该资源'
        break
      case 405:
        err.message = '请求方法未允许'
        break
      case 408:
        err.message = '请求超时'
        break
      case 500:
        err.message = '服务器端出错'
        break
      case 501:
        err.message = '网络未实现'
        break
      case 502:
        err.message = '网络错误'
        break
      case 503:
        err.message = '服务不可用'
        break
      case 504:
        err.message = '网络超时'
        break
      case 505:
        err.message = 'http版本不支持该请求'
        break
      default:
        err.message = `连接错误${err.response.status}`
    }
  } else {
    err.message = '连接到服务器失败'
  }
  //   message.err(err.message)
  return Promise.resolve(err.response)
})



// WEBPACK FOOTER //
// ./src/axios/index.js